
import { Component, Vue, Prop } from 'vue-property-decorator';
import Button from '../atoms/Button.vue';

interface Labels {
  headline: string
  button: string
}

enum Font {
  POPPINS = 'poppins',
  PT_MONO = 'mono',
}

@Component({
  components: {
    Button,
  },
})
export default class UserLogout extends Vue {
  @Prop({ default: false }) isDark!: boolean;
  @Prop({ required: true }) userName!: string;
  @Prop({ required: true }) labels!: Labels;
  @Prop({ default: Font.PT_MONO }) font!: Font;
  @Prop() userImageUrl!: string | null;

  get classNames() {
    return [
      { 'user-logout--dark': this.isDark },
    ];
  }

  get textMargin(): string {
    return this.font === Font.POPPINS ? '0px' : '6px';
  }

  get style() {
    return {
      fontFamily: this.font === Font.POPPINS ? '"Poppins", sans-serif' : '"PT Mono", monospace',
    };
  }
}
